// extracted by mini-css-extract-plugin
module.exports = {"featureText":"_2wY7A","section":"_2u0PA"};